<template>
  <div style="background-color: #edf4fc;padding-bottom: 0.2rem;">
    <div class="content-title">
      <span style="font-size: 0.3rem; line-height: 0.6rem">期刊专著</span>
    </div>
    <div class="content-body">
      <div class="content-body-press">
        <div class="content-body-press-header">出版社</div>
        <div class="content-body-press-content">
          <div class="content-body-press-content-div">科学出版社</div>
          <div class="content-body-press-content-div">人民邮电出版</div>
          <div class="content-body-press-content-div">经济管理出版社</div>
        </div>
        <div class="content-body-press-content">
          <div class="content-body-press-content-div">北京大学出版社</div>
          <div class="content-body-press-content-div">清华出版社</div>
          <div class="content-body-press-content-div">中国言实出版社</div>
        </div>
        <div class="content-body-press-content">
          <div class="content-body-press-content-div">社会科学文献出版社</div>
          <div class="content-body-press-content-div">中国言实出版社</div>
          <div class="content-body-press-content-div">中国旅游出版社</div>
        </div>
        <div class="content-body-press-content">
          <div class="content-body-press-content-div">人民出版社</div>
          <div class="content-body-press-content-div"></div>
          <div class="content-body-press-content-div"></div>
        </div>
      </div>
      <div>
        <div class="content-body-journal">
          <div class="content-body-press-header">期刊</div>
          <div class="content-body-press-content">
            <div class="content-body-journal-content-div">《技术经济与管理研究》</div>
          </div>
          <div class="content-body-press-content">
            <div class="content-body-journal-content-div">《企业管理》</div>
          </div>
        </div>
      </div>
    </div>
    <div class="science-press">
      <h3 style="font-size: 0.24rem;">科学出版社</h3>
      <img src="@/assets/science.jpg" alt="科学出版社" style="display: block;margin: 0 auto;">
      <h5 style="font-size: 0.16rem;text-indent: 0.3rem;">1.&nbsp;&nbsp;简介</h5>
      <p class="science-press-p">科学出版社（中国科技出版传媒股份有限公司）由中国科学院编译局与30年代创建的有较大影响的龙门联合书局于1954年8月合并成立，是中国最大的综合性科技出版机构，隶属于中国科学院。科学出版社拥有《中国科学》杂志社有限责任公司、北京龙腾八方文化有限责任公司、北京中科进出口有限责任公司等20多个下属分、子公司；在成都、武汉、南京、西安、石家庄、沈阳、广州，以及美国、日本均设立了分支机构；拥有完善的出版、发行网络。</p>
      <p class="science-press-p">科学出版社每年出书万余种，期刊近300种。位居科技出版社之首，被誉为“科学家的出版社”。</p>
      <p class="science-press-p">形成了重大图书出版项目、工程集群：每年大约有120个图书项目获国家科学技术学术著作出版基金、中国科学院出版基金、华夏基金资助；入围《“十二五”国家重点出版物出版规划》项目稳居全国科技出版单位之首；获得第三届中国出版政府奖8项，累积获得中国出版政府奖25项。</p>
      <p class="science-press-p">科学出版社科海新世纪书局有限公司以建筑、艺术、旅游、计算机等为主要出版方向，紧密围绕学科发展前沿，追踪国家重大重点科研计划，追求前瞻性、精品化和系列化，组织承担一系列国家重点图书出版规划项目，着力发展成为我国学科领域权威科技的发布中心。</p>
      <p class="science-press-p">科海新世纪书局全体同仁本着“承传科学传统，传播科学知识”的信念，将同广大的科学工作者密切合作，同时也委托策划顾问唐琦林老师参与书局的图书策划工作，为书局的业务贡献力量，为推动我国的科学技术进步做出新的贡献。</p>
      <h5 style="font-size: 0.16rem;text-indent: 0.3rem;">2.&nbsp;&nbsp;市场地位</h5>
      <p class="science-press-p">根据新闻出版广电总局发布的《2014年新闻出版产业分析报告》，科学出版社在全国科技类出版社中综合排名第一。</p>
      <h5 style="font-size: 0.16rem;text-indent: 0.3rem;">3.&nbsp;&nbsp;重点重大项目</h5>
      <p class="science-press-p">☛  入选国家各类基金以及国家级规划的项目数量</p>
      <p class="science-press-p">☛  位居全国科技社之首</p>
      <p class="science-press-p">☛  财政部文化产业发展专项资金：7项，支持资金达1.02亿元；</p>
      <p class="science-press-p">☛  “十二五”国家图书重点出版规划项目：90个；入选数位列全国第一。</p>
      <p class="science-press-p">☛  国家出版基金项目：17项，获资助额累计超过8000万元；</p>
      <p class="science-press-p">☛  国家科学技术学术著作出版基金项目：462项；每年获资助项目数占总资助项目数的一半左右；</p>
      <p class="science-press-p">☛  华夏英才基金项目：71项；</p>
      <p class="science-press-p">☛  国家社科基金后期资助项目：18项；</p>
      <p class="science-press-p">☛  国家哲学社会科学成果文库：3项；</p>
      <p class="science-press-p">☛  中国科学院科学出版基金项目：267项；</p>
      <h5 style="font-size: 0.16rem;text-indent: 0.3rem;">4.&nbsp;&nbsp;综合排名</h5>
      <img src="@/assets/rank.jpg" alt="综合排名" style="margin-left: 0.3rem;">
    </div>
  </div>
</template>

<script>
// 按需导入 API 接口
// import { getUserChannelAPI } from '@/api/homeAPI'

export default {
  name: 'Journal',
  data() {
    return {
    }
  },
  created() {},
  // 导航离开该组件的对应路由时调用
  // 可以访问组件实例 `this`
  beforeRouteLeave(to, from, next) {
    from.meta.top = window.scrollY
    setTimeout(() => {
      next()
    }, 0)
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.content-title {
  text-align: center;
  color: yellow;
  height: 0.6rem;
  background-color: #061238;
}
.content-body {
  margin-top: 0.4rem;
  overflow: hidden;
}
.content-body-press {
  border: 1px solid rgb(167, 255, 167);
  margin: 0.2rem;
  width: 4.8rem;
  font-size: 0.16rem;
  float: left;
}
.content-body-press-header {
  padding: 0.05rem;
  text-align: center;
  background-color: rgb(167, 255, 167);
}
.content-body-press-content {
  border-top: 1px solid rgb(167, 255, 167);
  overflow: hidden;
}
.content-body-press-content-div {
  float: left;
  width: 1.5rem;
  padding: 0.05rem;
  text-align: center;
}
.content-body-journal {
  border: 1px solid rgb(167, 255, 167);
  margin: 0.2rem;
  width: 2rem;
  font-size: 0.16rem;
  float: right;
}
.content-body-journal-content-div {
  float: left;
  width: 1.9rem;
  padding: 0.05rem;
  text-align: center;
}
.science-press {
  margin: 0.2rem;
}
.science-press-p {
  font-size: 0.15rem;
  text-indent: 0.3rem;
  text-align:justify;
  line-height: 1.6;
}
</style>
